"use client";
import EventPage from "@/components/Events/EventPage";

export default function EventCESPage() {
  return <EventPage />;
}
